(function() {
    'use strict';

    angular
        .module('app')
        .controller('ReferencedmodelController', ReferencedmodelController)

    ReferencedmodelController.$inject = ["ContentService", "$http", "$timeout", "$uibModal", "$log", "$document", "$sce", "prefixCampos", "$scope"];

    function ReferencedmodelController(ContentService, $http, $timeout, $uibModal, $log, $document, $sce, prefixCampos, scope) {
        var vm = this;
        vm.contentServiceV = ContentService;

        vm.rowClass = "";
        vm.params = {
            idEdit: '',
            field: '',
            node_type: '',
            items: []
        }
        vm.modalContenido = "";
        vm.prefixCampos = prefixCampos;
        vm.htmlDecode = function(input) {
            var e = document.createElement('div');
            e.innerHTML = input;
            return e.childNodes[0].nodeValue;
        }

        vm.duplicarRef = function(item) {
            //console.log(item.campos);
            vm.params.items.push({ id: "", campos: angular.copy(item.campos), allowEdit: 0 });
        }
        vm.initItem = function(item) {
            //console.log("initItem",item);
            if (item.id != "") {
                item.allowEdit = 1;
            }
        }
        vm.initPar = function(node_type, idEdit, field, field_id, fieldref_name) {
            console.log("scope", scope);
            console.log("idEdit", idEdit);
            console.log("field", field);
            console.log("field_id", field_id);
            console.log("fieldref_name", fieldref_name);
            vm.params.idEdit = idEdit;
            vm.params.field = field;
            vm.params.node_type = node_type;
            vm.params.actual_field_id = field_id;
            //vm.params.items=idEdit.items;
            //console.log("vm.contentServiceV.valueReferencedModel",vm.contentServiceV.valueReferencedModel[fieldref_name]);
            if (angular.isDefined(scope.$parent.control.camposActual["_campo_" + fieldref_name + "_1"]) && scope.$parent.control.camposActual["_campo_" + fieldref_name + "_1"] != '') {
                console.log("e", scope.$parent.control.camposActual["_campo_" + fieldref_name + "_1"]);
                var valueJson = JSON.parse(scope.$parent.control.camposActual["_campo_" + fieldref_name + "_1"]);
                //console.log("scope.rM.params.items",scope.$parent.control.camposActual["_campo_"+fieldref_name+"_1"]);
                vm.params.items = valueJson.items;
                //vm.params.items = scope.$parent.rM.params.items;
            } else {
                ContentService.getCamposModel(vm, function(data) {
                    vm.params.items = data.items;
                    //console.log(data);
                });
            }

            /*if(value!=""){
                value = vm.htmlDecode(value);
            }
            console.log(value);
            if(value!=""){
               value = JSON.stringify(value);
               value = value.replace(/\\n/g, "");
               value = value.replace(/\\r/g, "");
               value = value.replace(/\\t/g, "");
               value = value.replace(/([^>"]*)"(?=[^<]*>)/g, '$1\\\\"');
               value = JSON.parse(value);
               console.log(value);
               vm.params = JSON.parse(value);
               //console.log(vm.datos);
            }*/
        }

        vm.modalBorrar = "";
        vm.borrarItem = function(fieldName, item, index) {
            vm.modalBorrar = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title-top',
                ariaDescribedBy: 'modal-body-top',
                templateUrl: 'borrar_' + fieldName + '.html',
                size: 'lg',
                controller: function($scope) {
                    $scope.koForm = function() {
                        vm.modalBorrar.close();
                    }
                    $scope.okForm = function() {
                        vm.params.items.splice(index, 1);
                        vm.modalBorrar.close();
                    }
                }
            });

        }
        vm.initPopup = function(fieldName, id, nodetype, searchModel, editItem, index) {
            console.log("editItem", editItem);
            vm.type = nodetype;
            vm.params.node_type = nodetype;
            vm.lang_id_copy = 0;
            vm.duplicar = 0;
            vm.content_id = id;
            vm.lang_id = 1;
            vm.languages = [];
            vm.campos = [];
            vm.camposFinal = [];
            ContentService.getCampos(vm, function(data) {
                vm.languages = data.languages;
                vm.campos = data.campos;
                vm.camposHtml = data.html;
                vm.modalContenido = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title-top',
                    ariaDescribedBy: 'modal-body-top',
                    templateUrl: 'content_' + fieldName + '.html',
                    size: 'lg',
                    controller: function($scope) {
                        $scope.cc = vm;
                        $scope.camposHtml = vm.camposHtml;

                        $scope.cc.camposActual = {};
                        $scope.cc.opcionesextra = {};

                        if (typeof (editItem) != 'undefined') {
                            console.log("editItemtypeof1", editItem);
                            for (var cont = 0; cont < editItem.campos.length; cont++) {
                                for (var cont2 = 0; cont2 < data.languages.length; cont2++) {
                                    //console.log("field",vm.prefixCampos+data.campos[cont]["name"]+"_"+data.languages[cont2].id);
                                    //console.log("value",editItem.campos[cont]["value"][data.languages[cont2].id]);
                                    vm.camposActual[vm.prefixCampos + data.campos[cont]["name"] + "_" + data.languages[cont2].id] = (angular.isDefined(editItem.campos[cont]["value"][data.languages[cont2].id]) ? editItem.campos[cont]["value"][data.languages[cont2].id].value : '');
                                }
                            }
                            console.log("vm.camposActual", vm.camposActual);
                        } else {
                            //console.log("editItemtypeof2",editItem);

                        }/*else{
                        for(var cont=0;cont<data.campos.length;cont++){
                          for(var cont2=0;cont2<data.languages.length;cont2++){
                              vm.camposActual[vm.prefixCampos+data.campos[cont]["name"]+"_"+data.languages[cont2].id] = data.node[data.languages[cont2].id][data.campos[cont]["name"]];
                          }
                        }
                    }*/
                        $scope.koForm = function() {
                            vm.modalContenido.close();
                        }
                        $scope.okForm = function() {
                            /*for(var cont=0;cont<vm.campos.length;cont++){
                                    vm.campos[cont]["value"] = vm.camposActual[vm.prefixCampos+vm.campos[cont]["name"]];
                                }*/
                            for (var cont = 0; cont < vm.campos.length; cont++) {
                                vm.campos[cont]['value'] = {};
                                for (var cont2 = 0; cont2 < vm.languages.length; cont2++) {
                                    vm.campos[cont]['value'][vm.languages[cont2].id] = { "value": vm.camposActual[vm.prefixCampos + vm.campos[cont]["name"] + "_" + vm.languages[cont2].id] };

                                    /*if(angular.isUndefined(vm.contentServiceV.valueReferencedModel[data.campos[cont].name])){
                                        vm.contentServiceV.valueReferencedModel[data.campos[cont].name] = {};
                                    }*/
                                    /*vm.contentServiceV.valueReferencedModel[data.campos[cont].name][vm.languages[cont2].id] = {"value" : vm.camposActual[vm.prefixCampos+vm.campos[cont]["name"]+"_"+vm.languages[cont2].id] };
                                    if(angular.isUndefined(editItem)){
                                        //ponemos un codigo random
                                        vm.contentServiceV.valueReferencedModel[data.campos[cont].name][vm.languages[cont2].id].idNew = Math.floor(Math.random() * 1000000000000000000);
                                        vm.campos[cont]['value'][vm.languages[cont2].id].idNew = idNew;
                                    }else{
    
                                    }
                                    console.log("aki",vm.contentServiceV.valueReferencedModel);*/
                                    if (!vm.campos[cont].multilang) {
                                        break;
                                    }
                                }
                            }
                            ContentService.getValueCamposModel(vm, function(data) {
                                if (editItem) {
                                    vm.params.items[index].campos = data.item;
                                    vm.params.items[index].allowEdit = 0;
                                } else {
                                    vm.params.items.push({ id: data.id, campos: data.item, allowEdit: 0 });
                                }
                                console.log("vm.params.items", vm.params.items);
                            });
                            vm.modalContenido.close();
                        }
                    }
                });
            });
        }

    }

})();
